import { seatMap } from "../utils";

const OwnerSearch = ({ searchQuery, handleSearchQuery, clearSearch, searchOwner }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Name</label>
          <input
            type="text"
            placeholder="Search by name"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('name', e.target.value)}
            value={searchQuery.name || ''}
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Mobile</label>
          <input
            type="number"
            placeholder="Search by mobile"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => {
              let value = e.target.value;

              // Remove leading 88 if present
              if (value.startsWith('88')) {
                value = value.slice(2);
              }

              // Create/get error message div
              const errorDiv = e.target.parentElement.querySelector('.error-message') || document.createElement('div');
              errorDiv.className = 'error-message text-red-500 text-sm mt-1';

              // Validate length
              if (value.length < 11 && value.length > 0) {
                errorDiv.textContent = 'Phone number must be 11 digits';
              } else {
                errorDiv.textContent = '';
              }

              // Add error div if not present
              if (!e.target.parentElement.querySelector('.error-message')) {
                e.target.parentElement.appendChild(errorDiv);
              }

              // Only allow 11 or fewer digits
              let regex = /^[0-9]{0,11}$/;
              if (regex.test(value)) {
                handleSearchQuery('mobile', value)
              }
            }}
            value={searchQuery.mobile || ''}
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Vehicle Status</label>
          <select
            name="hasVehicle"
            id="hasVehicle"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('hasVehicle', e.target.value)}
            value={searchQuery.hasVehicle || 'all'}
          >
            <option value="all">All Vehicles</option>
            <option value="yes">Has Vehicle</option>
            <option value="no">No Vehicle</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Driver Status</label>
          <select
            name="hasDriver"
            id="hasDriver"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('hasDriver', e.target.value)}
            value={searchQuery.hasDriver || 'all'}
          >
            <option value="all">All Drivers</option>
            <option value="yes">Has Driver</option>
            <option value="no">No Driver</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Verification Status</label>
          <select
            name="verificationStatus"
            id="verificationStatus"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('isVerifiedAsOwner', e.target.value)}
            value={searchQuery.isVerifiedAsOwner || 'all'}
          >
            <option value="all">All Status</option>
            <option value="true">Verified</option>
            <option value="false">Not Verified</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">Division</label>
          <select
            name="division"
            id="division"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('division', e.target.value)}
            value={searchQuery.division || 'all'}
          >
            <option value="all">All Divisions</option>
            <option value="Dhaka">Dhaka</option>
            <option value="Chattogram">Chattogram</option>
            <option value="Rajshahi">Rajshahi</option>
            <option value="Khulna">Khulna</option>
            <option value="Barishal">Barishal</option>
            <option value="Sylhet">Sylhet</option>
            <option value="Rangpur">Rangpur</option>
            <option value="Mymensingh">Mymensingh</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700 mb-1">From District</label>
          <input
            type="text"
            placeholder="District Name"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('fromDistrict', e.target.value)}
            value={searchQuery.fromDistrict || ''}
          />
        </div>
      </div>

      <div className="flex items-center justify-between mt-4 space-x-3">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
            <select
              value={searchQuery.vehicleType || ''}
              onChange={(e) => {
                handleSearchQuery('vehicleType', e.target.value)
                handleSearchQuery('vehicleSeats', seatMap[e.target.value])
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            >
              <option value="">All</option>
              <option value="Sedan">Sedan</option>
              <option value="Micro">Micro</option>
              <option value="Private Car">Private Car</option>
              <option value="CNG">CNG</option>
              <option value="Bike">Bike</option>
            </select>
          </div>
          <div className="flex flex-col space-y-1">
            <label className="block text-sm font-medium text-gray-700">Vehicle Seat</label>
            <select
              value={searchQuery.vehicleSeats || ''}
              onChange={(e) => handleSearchQuery('vehicleSeats', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            >
              {searchQuery.vehicleType === "Private Car" && <option value="4">4</option>}
              {searchQuery.vehicleType === "Micro" &&
                <>
                  <option value="7">7</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                </>
              }
              {searchQuery.vehicleType === "CNG" && <option value="3">3</option>}
              {searchQuery.vehicleType === "Sedan" && <option value="4">4</option>}
              {searchQuery.vehicleType === "Bike" && <option value="2">2</option>}
            </select>
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Car Model</label>
            <input
              type="text"
              placeholder="Search by car model"
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={(e) => handleSearchQuery('model', e.target.value)}
              value={searchQuery.model || ''}
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Car Year</label>
            <input
              type="number"
              placeholder="Search by car year"
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={(e) => handleSearchQuery('year', e.target.value)}
              value={searchQuery.year || ''}
            />
          </div>

          <div className="flex flex-col col-span-2">
            <label className="text-sm font-medium text-gray-700 mb-1">Car Registration Date Range</label>
            <div className="flex flex-row gap-2">
              <input
                type="date"
                className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => handleSearchQuery('carRegistrationStartDate', e.target.value)}
                value={searchQuery.carRegistrationStartDate || ''}
                max={searchQuery.carRegistrationEndDate || ''}
              />
              <input
                type="date"
                className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => handleSearchQuery('carRegistrationEndDate', e.target.value)}
                value={searchQuery.carRegistrationEndDate || ''}
                min={searchQuery.carRegistrationStartDate || ''}
              />
            </div>
          </div>

        </div>
        <div className="flex gap-4 h-11 mt-5">
          <button
            className="px-4 py-2 bg-red-100 text-gray-700 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
            onClick={clearSearch}
          >
            Clear
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={() => searchOwner()}
            onKeyDown={(e) => e.key === 'return' && searchOwner()}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  )
}

export default OwnerSearch;
